import { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function PasswordInput({
  value,
  onChange,
  placeholder = "••••••••",
  testId = "password-input",
  minLength,
  required = true,
  autoComplete = "current-password",
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
      <input
        type={show ? "text" : "password"}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        data-testid={testId}
        className="w-full pl-11 pr-11 py-3.5 rounded-lg bg-white border border-black/[0.08] focus:border-[#00D4FF]/60 focus:ring-2 focus:ring-cyan-400/20 outline-none transition text-[#0E0E1A] placeholder:text-[#9191A8]"
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#2060EE] transition-colors p-1"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
